<template>
	<div class='lm-intro'>
    <h2>MoPaaS大模型 AI 平台</h2>
    <div class="box">
      <div class="content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;MoPaaS大模型AI 平台为用户提供从算力优化到LLMOps的全栈大模型应用工程解决方案。大模型AI平台基于自主研发的MoPaaS AI平台技术架构，端到端地实现生成式 AI 应用开发与部署流程，涵盖从大模型资产管理、模型训练/微调、提示工程到模型部署的大模型全生命周期。大模型AI 平台使用户可以在其专有、安全、合规环境中进行大模型相关的实验、协作、训练和推理，打造满足其场景需求的专有大模型和应用。</div>
      <img src="../assets/images/lm_intro.png"/>
<!--					<video :src="data" height="100%" controls="controls"></video>-->
      </div>
	</div>
</template>

<script>
	export default {
		name: 'AiIntro'
	}
</script>

<style>
  @media (min-width:992px) {
    .lm-intro {
      background: #F5F6F9;
      padding: 88px 0;
    }

    .lm-intro h2 { 
      margin: 0 auto;
      width: 320px;
      height: 34px;
      font-size: 30px;
      font-weight: 500;
      color: #3A3F4D;
      line-height: 34px;
    }
    .lm-intro .box {
      width: 1400px;
      margin: 40px auto 0;
    }
    .lm-intro .box img {
      margin: 34px auto 0;
      width: 977px;
      height: 256px;
    }
    .lm-intro .box .content {
      font-size: 20px;
      font-weight: 400;
      color: #333333;
      line-height: 36px;
      text-align: center;
    }
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/LmIntro.vue